import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Scanner from "./Scanner";
import AdminPanel from "./componentsadmin/AdminPanel";
import LoginUser from "./LoginUser";
import LoginAdmin from "./LoginAdmin";
import api from "./Api";
import { getAuthToken, hasAnyAuthRole, hasAuthRole, setAuthSession } from "./auth";

export default function App() {
  const [, setSessionVersion] = useState(0);
  const userLoggedIn = hasAnyAuthRole(["user", "admin"]);
  const adminLoggedIn = hasAuthRole("admin");

  useEffect(() => {
    if (!getAuthToken()) return;
    api.get("/api/auth/me")
      .then((res) => {
        const token = getAuthToken();
        if (!token || !res.data?.user) return;
        setAuthSession({ token, user: res.data.user });
        setSessionVersion(version => version + 1);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="app-background">
      <Router>
        <Routes>
          <Route path="/" element={userLoggedIn ? <Scanner /> : <LoginUser />} />
          <Route path="/admin/login" element={<LoginAdmin />} />
          <Route path="/admin/*" element={adminLoggedIn ? <AdminPanel /> : <Navigate to="/admin/login" />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </Router>
    </div>
  );
}
